<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: ''
}
</script>

<style lang='less' scoped>

</style>
